/**
 * Remove all characters that is not valid in a DMS formatted string.
 * Valid entries are: digits, dot, degrees symbol °, and direction letters N/S/E/W.
 */
export const cleanDmsFormat = (value?: string) => {
  if (!value) return;
  value = value
    .replace(',', '.')
    .replaceAll(' ', '')
    .replaceAll(/((?!\d|°|\.|[NSEWnsew]).)/gi, '');
  return value.trim();
};

export const isDmsGpsPosition = (value?: string | undefined) => {
  if (!value) return false;
  return value.match(/^\d+°\d+\.\d+[NSEWnsew]?$/gi)?.length === 1;
};
